/**
 * Guarda Mundo — título da newsletter em uma linha dentro do card (largura do card).
 * Ajusta font-size entre min/max para caber sem quebra; respeita prefers-reduced-motion (sem animação).
 */
(function () {
  const HEADING_SELECTOR = '.gm-newsletter-card__heading[data-gm-fit-text]';

  /**
   * @param {HTMLElement} heading
   * @returns {boolean}
   */
  function isVisible(heading) {
    return heading.getClientRects().length > 0;
  }

  /**
   * @param {HTMLElement} heading
   */
  function fitHeading(heading) {
    const card = heading.closest('.gm-newsletter-card');
    if (!card || !isVisible(heading)) return;

    const containerWidth = card.clientWidth;
    if (containerWidth <= 0) return;

    const styles = getComputedStyle(heading);
    const maxPx =
      parseFloat(styles.getPropertyValue('--gm-newsletter-heading-size-max')) || 20;
    const minPx =
      parseFloat(styles.getPropertyValue('--gm-newsletter-heading-size-min')) || 12;

    heading.style.fontSize = `${maxPx}px`;

    let textWidth = heading.scrollWidth;
    if (textWidth <= containerWidth) return;

    let size = Math.max(minPx, Math.floor(((maxPx * containerWidth) / textWidth) * 100) / 100);
    heading.style.fontSize = `${size}px`;

    textWidth = heading.scrollWidth;
    if (textWidth > containerWidth && size > minPx) {
      size = Math.max(
        minPx,
        Math.floor(((size * containerWidth) / textWidth) * 100) / 100 - 0.15
      );
      heading.style.fontSize = `${size}px`;
    }
  }

  /** @type {WeakMap<HTMLElement, ResizeObserver>} */
  const observers = new WeakMap();

  /**
   * @param {HTMLElement} heading
   */
  function bindHeading(heading) {
    if (observers.has(heading)) return;

    const card = heading.closest('.gm-newsletter-card');
    if (!card) return;

    const run = () => fitHeading(heading);
    const ro = new ResizeObserver(run);
    ro.observe(card);
    observers.set(heading, ro);

    run();
  }

  function initAll() {
    document.querySelectorAll(HEADING_SELECTOR).forEach((el) => {
      if (el instanceof HTMLElement) bindHeading(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (document.fonts?.ready) {
    document.fonts.ready.then(initAll);
  }

  window.addEventListener('resize', initAll, { passive: true });
})();
